import React, { FC } from "react";
import { JobPostEditorSectionLayout } from "@components/Layout/JobPostEditorSectionLayout";
import { useFormContext } from "react-hook-form";
import { Input } from "@components/Form/Input";

interface Props {
  isLast?: boolean;
}

export const NewUserSection: FC<Props> = ({ isLast }) => {
  const {
    getValues,
    watch,
    setValue,
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  return (
    <JobPostEditorSectionLayout
      title="User details"
      description="Provide your email address to create a new user account. This will be private and will NOT be shown in the JobPost."
      isLast={isLast}
    >
      <div className="col-span-6">
        <Input
          label="Your email"
          path="userEmail"
          register={register}
          errors={errors}
        />
      </div>
    </JobPostEditorSectionLayout>
  );
};
